import { useNavigate } from 'react-router-dom';
import React, { useState } from 'react';
import { useAuth } from '../../../AuthContext'; // Cambia la ruta según tu estructura de archivos
import LoginBG from '../../static/images/login-bg.png';
import Logo from '../../static/images/n-logo.png';
import '../../static/styles/login.css';

const LoginForm = () => {
  const { axiosInstance, setAuthTokenAndFetchProfile } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (username, password) => {
    try {
      const response = await axiosInstance.post('token/', {
        username,
        password,
      });

      let {access, refresh} = response.data;
      await setAuthTokenAndFetchProfile(access, refresh); 
      navigate('/');
      
    } catch (error) {
      setError('Login failed. Please check your credentials.');
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    handleLogin(username, password);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleLogin(username, password);
    }
  };

  return (
    <div className='appLogin'>
      <div className='app-login-container-right'>
        <img src={LoginBG} className='login-bg' alt='login' />
      </div>
      <div className='app-login-container-left'>
        <div className='login-form-container'>
          <img src={Logo} className='n-logo' alt='n-logo' />
          <form onSubmit={handleSubmit}>
            <div className='login-form'>
              <p className='form-title'>Sign in</p>
              <p className='form-subtitle'>Enter your username and password</p>
              <input
                className='form-input-value'
                type="text"
                id="username"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <input
                className='form-input-value'
                type="password"
                id="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <div className='login-line'></div>
              <button className='form-button' type="submit">Login</button>
              {error && <p className='error-message'>{error}</p>}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
